import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface State {
  isRefreshLearners: boolean;
}

interface Store {
  state: State;
  setIsRefreshLearners: (payload: boolean) => void;
}

const initState: State = {
  isRefreshLearners: false,
};

export const useLearnerStore = create(
  immer<Store>((set) => ({
    state: initState,
    setIsRefreshLearners: (payload: boolean) => {
      set((store) => {
        store.state.isRefreshLearners = payload;
      });
    },
  })),
);

export const { setIsRefreshLearners } = useLearnerStore.getState();

export const isRefreshSelector = (s: Store) => s.state.isRefreshLearners;
